import { useEffect, useState, useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import {
  MedVoxEventRequest,
  getMedVoxEvents,
  medVoxStatus,
  selectMedVoxEvents,
  totalMedVoxEvents,
} from '../../store/reducers/MedVoxEventSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';

const PAGE_SIZE: number = 20;

export const useMedVoxEvents = () => {
  const events = useAppSelector(selectMedVoxEvents);
  const status = useAppSelector(medVoxStatus);
  const totalCount = useAppSelector(totalMedVoxEvents);

  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const dispatch = useAppDispatch();

  const [eventRequest, setEventRequest] = useState<MedVoxEventRequest>({
    selectedDate: dayjs().format('DD.MM.YYYY'),
    Filter: dayjs().format('YYYY-MM-DD'),
    PageIndex: 0,
    PageSize: pageSize,
  } as MedVoxEventRequest);

  const currentEvents = useMemo(
    () =>
      events.map((event) => ({
        id: event.id,
        eventType: event.eventType,
        message: event.message,
        createdDate: event.createdDate.slice(11, 16),
        source: event.source,
      })),
    [events],
  );

  useEffect(() => {
    dispatch(getMedVoxEvents(eventRequest));
  }, [eventRequest]);

  const handleChange = useCallback(
    (page: number, pageItemCount: number) => {
      setPageSize(pageItemCount);
      setEventRequest({
        ...eventRequest,
        PageIndex: page - 1,
        PageSize: pageItemCount,
      });
    },
    [setEventRequest, eventRequest],
  );

  return {
    status,
    totalCount,
    currentEvents,
    handleChange,
    setEventRequest,
    eventRequest,
    pageSize,
  };
};
